import {emojiIndex} from "emoji-mart"
import {filter} from "lodash"

import {SUPPRESSED_LIST} from "../constants"

const emojiSearch = (searchString) => {
  if (!searchString) {
    return []
  }

  return filter(emojiIndex.search(searchString), (emoji) => !SUPPRESSED_LIST.includes(emoji.id))
}

export default emojiSearch
